<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <!-- 로그인 — CMS 스킨 '판면'(2026-09-24). 수정안 1번 "전체 배경 칼러 및 디자인 / 폰트".
         Vuexy 기본 일러스트를 걷어내고 제호와 도메인을 세운다. -->
    <div class="pm-login" id="page-login">
        <div class="pm-login-box">
            <!-- 왼쪽: 제호 -->
            <div class="pm-brand">
                <img src="@/assets/images/logo/joongang-ci.png" alt="" class="pm-brand-mark">
                <p class="pm-brand-kicker">CMS</p>
                <h1 class="pm-brand-title">중앙신문</h1>
                <p class="pm-brand-url">WWW.JASM.CO.KR</p>
            </div>

            <!-- 오른쪽: 입력 -->
            <div class="pm-form">
                <h2 class="pm-form-title">로그인</h2>
                <p v-if="$route.query.session === 'expired'" role="status">로그인 시간이 만료되었습니다. 다시 로그인해 주세요.</p>
                <vs-input
                    name="Id"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="아이디"
                    v-model="id"
                    class="w-full no-icon-border"/>
                <vs-input
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="비밀번호"
                    v-model="password"
                    class="w-full mt-6 no-icon-border"
                    @keyup.enter="onClick(id, password)" />

                <div class="pm-form-row">
                    <vs-checkbox v-model="checkbox_remember_me">아이디 저장</vs-checkbox>
                </div>
                <p class="pm-msg" v-if="msg">{{msg}}</p>
                <vs-button class="pm-submit" @click="onClick(id, password)">로그인</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
export default {
    data() {
        return {
            id: '',
            password: '',
            msg: '',
            checkbox_remember_me: false
        }
    },
    methods: {
      onClick(id, password) {
        //   const thisIns = this;
        this.$store.dispatch('LOGIN', {id, password})
          .then(() => {
            //   console.log(this)
            this.redirect()
          })
          .catch(({message}) => this.msg = message)
      },
      keydown(e){
          console.log('asdf', e);
      },
      redirect() {
        const target = this.$route.query.to;
        const to = typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') ? target : '';
        if(to) {
          const query = { ...this.$route.query };
          delete query.to;
          delete query.session;
          this.$router.push(to.includes('?') ? to : { path: to, query });
        }
        else {
            // if(this.$store.state.AppActiveUser.department == 'g1') { this.$router.push({path: '/newsListAll?department=g1'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g2') { this.$router.push({path: '/newsListAll?department=g2'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g3') { this.$router.push({path: '/newsListAll?department=g3'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g4') { this.$router.push({path: '/newsListAll?department=g4'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g5') { this.$router.push({path: '/newsListAll?department=g5'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g6') { this.$router.push({path: '/newsListAll?department=g6'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g7') { this.$router.push({path: '/newsListAll?department=g7'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g8') { this.$router.push({path: '/newsListAll?department=g8'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g9') { this.$router.push({path: '/newsListAll?department=g9'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g10') { this.$router.push({path: '/newsListAll?department=g10'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g11') { this.$router.push({path: '/newsListAll?department=g11'}) }
            // else if(this.$store.state.AppActiveUser.department == 'g12') { this.$router.push({path: '/newsListAll?department=g12'}) }
            if(this.$store.state.AppActiveUser.department && this.$store.state.AppActiveUser.department == 'g14') { 
                this.$router.push({path: '/newsListAll?department=g7'}) 
            }else if(this.$store.state.AppActiveUser.department && this.$store.state.AppActiveUser.department != 'g0') { 
                this.$router.push({path: '/newsListAll?department=' + this.$store.state.AppActiveUser.department}) 
            }
            else { this.$router.push({path: '/newsListAll?department=all'}) }
        }
      }
    },
    created() {
        // if (this.$store.getters.isAuthenticated){
        //     // console.log(this.$store.getters.isAuthenticated);
        //     console.log(this, this.$store.getters.isAuthenticated)
        //     this.redirect()
        // }
    }
}
</script>

<style lang="scss">
/* 로그인 — CMS 스킨 '판면'. 색·서체는 custom-style/skin-panmyeon.scss 와 같은 값이다. */
$pm-ink: #111111;
$pm-muted: #767676;
$pm-accent: #EA2121;
$pm-rule: #D9D9D9;

.pm-login {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    /* 종이 결을 흉내낸 아주 옅은 미색 — 순백 카드가 떠 보이게 한다. */
    background: #F4F3F1;
    font-family: 'IBM Plex Sans KR', 'Noto Sans KR', sans-serif;
}
.pm-login-box {
    display: grid;
    grid-template-columns: 300px minmax(0, 380px);
    width: 100%;
    max-width: 680px;
    background: #fff;
    border: 1px solid $pm-rule;
}
@media (max-width: 720px) {
    .pm-login-box { grid-template-columns: 1fr; max-width: 420px; }
}

/* 왼쪽 제호 — 먹색 판. 수정안 1번의 예시(로고 + 도메인)를 그대로 세운다. */
.pm-brand {
    background: $pm-ink;
    color: #fff;
    padding: 46px 34px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.pm-brand-mark { width: 46px; height: 46px; display: block; margin-bottom: 20px; }
.pm-brand-kicker {
    margin: 0 0 2px;
    font-size: 13px;
    letter-spacing: .3em;
    font-weight: 600;
    color: $pm-accent;
}
.pm-brand-title {
    font-family: 'Nanum Myeongjo', serif;
    font-weight: 800;
    font-size: 36px;
    line-height: 1.15;
    margin: 0 0 14px;
    color: #fff;
    letter-spacing: -0.01em;
}
.pm-brand-url {
    margin: 0;
    padding-top: 14px;
    border-top: 1px solid rgba(255, 255, 255, .18);
    font-size: 11.5px;
    letter-spacing: .12em;
    color: #9A9A9A;
}

/* 오른쪽 입력 */
.pm-form { padding: 46px 38px; }
.pm-form-title {
    font-family: 'Nanum Myeongjo', serif;
    font-weight: 700;
    font-size: 22px;
    margin: 0 0 30px;
    color: $pm-ink;
}
.pm-form-row { margin: 22px 0 18px; }
.pm-msg { color: $pm-accent; font-size: 13px; margin: 0 0 12px; }
/* 🔴 Vuesax 가 `.vs-button-primary.vs-button-filled` 로 보라(#7367F0)를 칠하는데
   **그쪽도 !important** 다. 둘 다 !important 면 특이도가 이긴다 —
   (0,2,0) vs 한 클래스 (0,1,0) 이라 `.pm-submit` 혼자로는 진다.
   클래스를 겹쳐 (0,3,0) 으로 올린다. */
.pm-login .pm-submit.vs-button-filled {
    width: 100%;
    border-radius: 3px !important;
    background: $pm-ink !important;
    font-weight: 600;
    &:hover { background: #2B2B2B !important; }
}
.pm-submit { width: 100%; }
.pm-login .vs-input--input {
    border-radius: 3px !important;
    border-color: $pm-rule !important;
    &:focus { border-color: $pm-ink !important; }
}

#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #1551b1;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
